var installedModules = {};
var moduleToHandlerMapping = {
	10362: {
		getter: () => (() => (__webpack_require__(96540))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "18.2.0",
			  "strictVersion": true,
			  "singleton": false,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "react",
	},
	72040: {
		getter: () => (() => (__webpack_require__(40961))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "18.2.0",
			  "strictVersion": true,
			  "singleton": false,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "react-dom",
	},
	26050: {
		getter: () => (Promise.all([__webpack_require__.e(5655), __webpack_require__.e(5137)]).then(() => (() => (__webpack_require__(17518))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "11.11.1",
			  "strictVersion": true,
			  "singleton": false,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@emotion/react",
	},
	35453: {
		getter: () => (__webpack_require__.e(3860).then(() => (() => (__webpack_require__(71479))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "11.11.0",
			  "strictVersion": true,
			  "singleton": false,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@emotion/styled",
	},
	78326: {
		getter: () => (__webpack_require__.e(9677).then(() => (() => (__webpack_require__(69677))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "3.17.0",
			  "strictVersion": true,
			  "singleton": false,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@azure/msal-browser",
	},
	8323: {
		getter: () => (Promise.all([__webpack_require__.e(213), __webpack_require__.e(9612)]).then(() => (() => (__webpack_require__(29612))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "3.0.2",
			  "strictVersion": true,
			  "singleton": false,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@microsoft/applicationinsights-clickanalytics-js",
	},
	13944: {
		getter: () => (__webpack_require__.e(2389).then(() => (() => (__webpack_require__(32389))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "14.1.0",
			  "strictVersion": true,
			  "singleton": false,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "react-i18next",
	},
	18959: {
		getter: () => (__webpack_require__.e(7971).then(() => (() => (__webpack_require__(57971))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "5.3.0",
			  "strictVersion": true,
			  "singleton": false,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "history",
	},
	20541: {
		getter: () => (() => (__webpack_require__(69418))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "1.6.2",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "axios",
	},
	26300: {
		getter: () => (Promise.all([__webpack_require__.e(127), __webpack_require__.e(5666)]).then(() => (() => (__webpack_require__(90127))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "1.9.3",
			  "strictVersion": true,
			  "singleton": false,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@reduxjs/toolkit",
	},
	33740: {
		getter: () => (__webpack_require__.e(4213).then(() => (() => (__webpack_require__(4213))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "2.0.5",
			  "strictVersion": true,
			  "singleton": false,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "file-saver",
	},
	35207: {
		getter: () => (__webpack_require__.e(9970).then(() => (() => (__webpack_require__(29970))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "2.1.0",
			  "strictVersion": true,
			  "singleton": false,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "react-ga4",
	},
	37173: {
		getter: () => (Promise.all([__webpack_require__.e(7037), __webpack_require__.e(1028), __webpack_require__.e(9020), __webpack_require__.e(8075)]).then(() => (() => (__webpack_require__(78075))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "5.11.16",
			  "strictVersion": true,
			  "singleton": false,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@mui/material",
	},
	41316: {
		getter: () => (Promise.all([__webpack_require__.e(3246), __webpack_require__.e(635)]).then(() => (() => (__webpack_require__(13246))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "3.8.2",
			  "strictVersion": true,
			  "singleton": false,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "jspdf-autotable",
	},
	43038: {
		getter: () => (__webpack_require__.e(9733).then(() => (() => (__webpack_require__(69733))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "8.0.5",
			  "strictVersion": true,
			  "singleton": false,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "react-redux",
	},
	45875: {
		getter: () => (__webpack_require__.e(9489).then(() => (() => (__webpack_require__(29489))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "3.4.3",
			  "strictVersion": true,
			  "singleton": false,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@microsoft/applicationinsights-react-js",
	},
	46241: {
		getter: () => (Promise.all([__webpack_require__.e(213), __webpack_require__.e(3988)]).then(() => (() => (__webpack_require__(53988))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "3.0.2",
			  "strictVersion": true,
			  "singleton": false,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@microsoft/applicationinsights-web",
	},
	51760: {
		getter: () => (__webpack_require__.e(6810).then(() => (() => (__webpack_require__(36810))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "2.0.20",
			  "strictVersion": true,
			  "singleton": false,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@azure/msal-react",
	},
	59260: {
		getter: () => (__webpack_require__.e(1347).then(() => (() => (__webpack_require__(1347))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "2.5.0",
			  "strictVersion": true,
			  "singleton": false,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "i18next-http-backend",
	},
	65780: {
		getter: () => (__webpack_require__.e(1287).then(() => (() => (__webpack_require__(93668))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "5.13.2",
			  "strictVersion": true,
			  "singleton": false,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@mui/styles",
	},
	77017: {
		getter: () => (__webpack_require__.e(2648).then(() => (() => (__webpack_require__(92648))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "6.11.2",
			  "strictVersion": true,
			  "singleton": false,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "react-router-dom",
	},
	77748: {
		getter: () => (__webpack_require__.e(2664).then(() => (() => (__webpack_require__(12664))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "1.4.0",
			  "strictVersion": true,
			  "singleton": false,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "yup",
	},
	86918: {
		getter: () => (__webpack_require__.e(796).then(() => (() => (__webpack_require__(90796))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "7.2.0",
			  "strictVersion": true,
			  "singleton": false,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "i18next-browser-languagedetector",
	},
	89394: {
		getter: () => (__webpack_require__.e(8084).then(() => (() => (__webpack_require__(88084))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "2.4.5",
			  "strictVersion": true,
			  "singleton": false,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "formik",
	},
	98892: {
		getter: () => (__webpack_require__.e(2635).then(() => (() => (__webpack_require__(72635))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "23.10.1",
			  "strictVersion": true,
			  "singleton": false,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "i18next",
	},
	99748: {
		getter: () => (__webpack_require__.e(276).then(() => (() => (__webpack_require__(40276))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^9.0.5",
			  "strictVersion": true,
			  "singleton": false,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "flagsmith",
	},
	45666: {
		getter: () => (__webpack_require__.e(1265).then(() => (() => (__webpack_require__(1265))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "2.4.2",
			  "strictVersion": true,
			  "singleton": false,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "redux-thunk",
	},
	50635: {
		getter: () => (__webpack_require__.e(5463).then(() => (() => (__webpack_require__(55463))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "2.5.1",
			  "strictVersion": true,
			  "singleton": false,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "jspdf",
	},
	75288: {
		getter: () => (__webpack_require__.e(3293).then(() => (() => (__webpack_require__(13293))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^3.7.7",
			  "strictVersion": true,
			  "singleton": false,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "js-base64",
	},
	87544: {
		getter: () => (__webpack_require__.e(9407).then(() => (() => (__webpack_require__(69407))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "1.2.1",
			  "strictVersion": true,
			  "singleton": false,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "mf-dynamic-remote-component",
	},
	96843: {
		getter: () => (__webpack_require__.e(364).then(() => (() => (__webpack_require__(364))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "2.1.4",
			  "strictVersion": true,
			  "singleton": false,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "web-vitals",
	},
	48084: {
		getter: () => (__webpack_require__.e(4717).then(() => (() => (__webpack_require__(94717))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "1.2.1",
			  "strictVersion": true,
			  "singleton": false,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "react-documents",
	}
};
var initialConsumes = [10362];
__webpack_require__.federation.installInitialConsumes = () => (__webpack_require__.federation.bundlerRuntime.installInitialConsumes({
	initialConsumes: initialConsumes,
	installedModules:installedModules,
	moduleToHandlerMapping:moduleToHandlerMapping,
	webpackRequire: __webpack_require__
}))
var chunkMapping = {
	"635": [
		50635
	],
	"2040": [
		72040
	],
	"5453": [
		35453
	],
	"5666": [
		45666
	],
	"6050": [
		26050
	],
	"6843": [
		96843
	],
	"7126": [
		8323,
		13944,
		18959,
		20541,
		26300,
		33740,
		35207,
		37173,
		41316,
		43038,
		45875,
		46241,
		51760,
		59260,
		65780,
		77017,
		77748,
		86918,
		89394,
		98892,
		99748
	],
	"8186": [
		75288,
		87544
	],
	"8326": [
		78326
	],
	"8792": [
		10362
	],
	"8810": [
		48084
	]
};
__webpack_require__.f.consumes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.consumes({
	chunkMapping: chunkMapping,
	installedModules: installedModules,
	chunkId: chunkId,
	moduleToHandlerMapping: moduleToHandlerMapping,
	promises: promises,
	webpackRequire:__webpack_require__
	});
}